import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/CreateAppointmentPage.css';

const CreateAppointmentPage = () => {
  const [selectedDevice, setSelectedDevice] = useState('');
  const [selectedTherapist, setSelectedTherapist] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [selectedTreatment, setSelectedTreatment] = useState('');
  const [startTime, setStartTime] = useState('');
  const [treatmentDuration, setTreatmentDuration] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const devices = [
    'Room 1 - Device 1',
    'Room 1 - Device 2',
    'Room 2 - Device 1',
    'Room 3 - Device 1',
  ];

  const therapists = ['Amy', 'Bella', 'Cathrine', 'Dolly'];

  const treatments = [
    'Bel-Air Signature Massage',
    'Bel-Air Bliss Massage',
    'Hot Stone Massage',
    'Reflexology Massage',
  ];

  const treatmentDurations = ['15mins', '30mins', '45mins', '1hour', '1hour15mins'];

  const handleScheduleAppointment = () => {
    if (
      selectedDevice &&
      selectedTherapist &&
      customerName &&
      selectedTreatment &&
      startTime &&
      treatmentDuration
    ) {
      setIsLoading(true);
      // Save the appointment data (e.g., to a database)
      console.log('Scheduling appointment:', {
        selectedDevice,
        selectedTherapist,
        customerName,
        selectedTreatment,
        startTime,
        treatmentDuration,
      });
      // Simulate saving data and show success message
      setTimeout(() => {
        setIsLoading(false);
        alert('Appointment scheduled successfully!');
        navigate('/scheduling');
      }, 2000);
    } else {
      alert('Please fill in all the required fields.');
    }
  };

  return (
    <div className="create-appointment-container">
      <h1 className="create-appointment-title">Create New Appointment</h1>
      <div className="create-appointment-form">
        <div className="form-group">
          <label className="form-label">Device:</label>
          <select
            className="form-select"
            value={selectedDevice}
            onChange={(e) => setSelectedDevice(e.target.value)}
          >
            <option value="">Select Device</option>
            {devices.map((device, index) => (
              <option key={index} value={device}>
                {device}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Therapist:</label>
          <select
            className="form-select"
            value={selectedTherapist}
            onChange={(e) => setSelectedTherapist(e.target.value)}
          >
            <option value="">Select Therapist</option>
            {therapists.map((therapist, index) => (
              <option key={index} value={therapist}>
                {therapist}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Customer Name:</label>
          <input
            className="form-input"
            type="text"
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="form-label">Treatment:</label>
          <select
            className="form-select"
            value={selectedTreatment}
            onChange={(e) => setSelectedTreatment(e.target.value)}
          >
            <option value="">Select Treatment</option>
            {treatments.map((treatment, index) => (
              <option key={index} value={treatment}>
                {treatment}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Start Time:</label>
          <input
            className="form-input"
            type="datetime-local"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label className="form-label">Treatment Duration:</label>
          <select
            className="form-select"
            value={treatmentDuration}
            onChange={(e) => setTreatmentDuration(e.target.value)}
          >
            <option value="">Select Duration</option>
            {treatmentDurations.map((duration, index) => (
              <option key={index} value={duration}>
                {duration}
              </option>
            ))}
          </select>
        </div>
        <button className="form-button" onClick={handleScheduleAppointment}>
          {isLoading ? 'Loading...' : 'Schedule Appointment'}
        </button>
      </div>
    </div>
  );
};

export default CreateAppointmentPage;